import {useList} from "@refinedev/core";
import {provider} from "../resources/refineConfig";

export const EXERCISES_RESOURCE = "exercices"

/**
 * Retrieves the list of exercises from the data provider.
 *
 * @returns {Object} An object containing the clients and loading status.
 * @property {Array.<>} exercises - The list of exercises.
 * @property {boolean} isLoadingExercises - A boolean indicating if the exercises are currently being loaded.
 */
export function getExercises() {
    const { data: dataExercises, isLoading: isLoadingExercises } = useList({
        dataProviderName: provider.las,
        resource: EXERCISES_RESOURCE,
        meta: {
            resourceName:"exercises",
        }
    });
    return { exercises: dataExercises?.data, isLoadingExercises };
}
